export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7ff98ec1db0f8371abba7679594a14d146610b6c57&name=fetchTypeahead!'